import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';

import { Modal, Button } from '@simplywallst/ui-core';

import type { Watchlist } from '@/hooks/useWatchlist';

type Props = {
  watchlist: Watchlist;
  onClose: () => void;
};

export const LimitModal = ({ watchlist, onClose }: Props) => {
  const makeTypeformPopup = useTypeformDrawer('IMPJMsax');

  return (
    <Modal
      fullscreen={true}
      title="Your Watchlist is full"
      onClose={onClose}
      onPrimaryClick={onClose}
      primaryLabel="Okay"
    >
      <>
        <p>
          You&apos;ve reached the {watchlist.itemsLimit}-stock limit for your
          Watchlist.
        </p>
        <p>
          To follow more stocks, you can create additional lists from the
          Watchlist dropdown.
        </p>
        <p>
          If that&apos;s not enough, we&apos;d love your input on how we can
          improve! Share your thoughts in this{' '}
          <Button
            styleType="strongLink"
            display="inline"
            onClick={makeTypeformPopup}
          >
            quick 2 minute survey.
          </Button>
        </p>
      </>
    </Modal>
  );
};
